import { defineSoldOnlyAdapter } from "../shared/sold-only.ts";
import { MARSHALL_WHITE_META } from "./meta.ts";
import { parseMarshallWhiteDetailHtml } from "./parser.ts";
import { buildSearchUrl } from "./runtime.ts";

export * from "./meta.ts";
export * from "./parser.ts";
export * from "./runtime.ts";

export const MARSHALL_WHITE_ADAPTER = defineSoldOnlyAdapter(
  MARSHALL_WHITE_META,
  buildSearchUrl,
  { parseDetailHtml: parseMarshallWhiteDetailHtml },
);
